<template>
  <v-container class="px-2 pt-10 pa-md-10 admin" dark v-if="this.user">
    <!-- ------------ FUNDO ------------ -->
    <v-row class="bg mx-0"></v-row>

    <v-row class="pl-2 pl-md-0">
      <h1 class="white--text z-2">Admin area</h1>
    </v-row>
    <v-row class="pl-2 pl-md-0">
      <p class="white--text z-2">Seja bem vindo(a), <b>{{ this.user.name }}</b></p>
      <!-- <p class="white--text z-2">Admin token: <b>{{ getAdminToken }}</b></p> -->
    </v-row>

    <v-row class="d-flex" justify="center">
      <!-- VIDEO DISPLAY -->
      <v-col cols="12" md="12">
        <v-card class="round-corner px-0 px-md-8">
          <v-row class="mb-0">
            <v-col cols="12" md="8" class="mb-0 pb-0">
              <!-- <v-img src="https://cdn.vuetifyjs.com/images/cards/cooking.png"></v-img> -->
              <v-card-title class="">
                Vídeo em display
              </v-card-title>
              <!-- {{this.video}} -->
              <v-sheet class="round-corner" width="100%" style="overflow-hidden">
                <v-responsive :aspect-ratio="16/9">
                  <iframe height="100%" width="100%" :src="video.url + '?autoplay=1&modestbranding=1'" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </v-responsive>
              </v-sheet>
            </v-col>
            <v-col cols="12" md="4">
              <GoLiveSwitch />
              <CommentsAdmin :id="this.videoId" />
            </v-col>
          </v-row>
          <!-- VER MAIS/MENOS -->
          <v-row>
            <v-col>
              <v-card-text>
                <v-divider></v-divider>
                <v-btn
                  text
                  block
                  large
                  @click="show = !show"
                  class="capitalize"
                >
                  Ver {{ show ? 'menos' : 'mais' }} <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
                <v-divider></v-divider>
                <v-expand-transition>
                  <div v-show="show">

                    <v-card-text>
                      <!-- title -->
                      <p><b>Título:</b> {{this.video.title}}</p>
                      <!-- content -->
                      <p><b>Descrição:</b> {{this.video.content}}</p>
                      <v-row>
                        <v-col col="12" md="6">
                          <!-- partocinio -->
                          <v-list dense>
                            <v-subheader>Patrocínio</v-subheader>
                            <v-list-item
                              v-for="(patrocinador, i) in video.patrocinio"
                              :key="i"
                            >
                              <v-list-item-content>
                                <v-list-item-title v-text="patrocinador"></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col col="12" md="6">
                          <!-- sponsors -->
                          <v-list dense>
                            <v-subheader>Organização</v-subheader>
                            <v-list-item
                              v-for="(org, i) in video.sponsors"
                              :key="i"
                            >
                              <v-list-item-content>
                                <v-list-item-title v-text="org"></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                      <p><b>Adicionado em:</b> {{this.video.dt}}</p>
                      <v-divider class="my-8"></v-divider>
                      <v-btn
                        outlined
                        color="teal"
                        large
                        block
                        class="mb-4 round-corner"
                        @click.stop="openEdit()"
                      >Editar este vídeo</v-btn>
                      <v-btn
                        block
                        color="teal white--text"
                        large
                        class="round-corner"
                        @click.stop="openAdd()"
                      >Adicionar novo vídeo</v-btn>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card-text>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
      <!-- BG -->
      <!-- <v-col cols="12" md="6">
        <v-card class="round-corner">
          <v-card-title class="">
            Background
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-card class="round-corner">
              <v-img
                v-if="this.bg"
                :src="this.bg"
                class="round-corner white--text align-end"
                gradient="to top, rgba(0,0,0,.5), rgba(0,0,0,0)"
              >
                <v-card-title>Background atual</v-card-title>
              </v-img>
            </v-card>
            <v-file-input
              :loading="loadingBg"
              show-size
              counter
              accept="image/*"
              label="Escolha uma nova imagem para o BG..."
              prepend-icon="mdi-file-image"
              append-outer-icon="mdi-send"
              @click:append-outer="changeBg()"
              dense
              v-model="newBg"
              color="blue white--text"
              class="my-auto mx-4 mt-4"
            >
            </v-file-input>
          </v-card-text>
        </v-card>
      </v-col> -->
      <!-- BUTTONS -->
      <v-col cols="12" md="6" class="px-0 px-md-12 py-8  my-0 my-md-2 justify-center align-center">
        <BackupBtn />
        <BackupUsers />
      </v-col>
      <v-col cols="12" md="6">
        <NewInsc />
      </v-col>
      <!-- INSCRITOS -->
      <v-col cols="12">
        <v-card class="round-corner">
          <v-card-title class="">
            Inscritos (<span class="">{{ this.userCount }}</span>)
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar inscritos"
              single-line
              hide-details
              class="mb-8"
            ></v-text-field>
            <!-- Veja as pessoas cadastradas em sua plataforma -->
             <!-- <v-simple-table v-if="usuarios" height="300px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Nome</th>
                    <th class="text-left">CRM</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(usuario, i) in usuarios" :key="i">
                    <td>{{ usuario.email }}</td>
                    <td>{{ usuario.crm }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table> -->
            <!-- data table -->
            <v-data-table
              v-if="usuarios"
              :headers="headers"
              :items="usuarios"
              :items-per-page="5"
              :search="search"
              class="elevation-0 round-corner"
              :loading="loading"
              loading-text="Carregando... Por favor, aguarde"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template v-slot:item.tsCadastro="{ item }">
                <v-chip
                  color="light-grey"
                >
                  {{ item.tsCadastro ? moment(item.tsCadastro).format('L') : item.tsCadastro}}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions class="">
            <!-- <v-btn
              color="orange"
              text
            > veja mais</v-btn> -->
            <v-spacer></v-spacer>
            <download-excel
              class   = "btn btn-default"
              :data   = "json_data"
              :before-generate = "startDownload"
              :before-finish = "finishDownload"
              :fields = "json_fields"
              :loading = "loadingCsv"
              worksheet = "Inscritos Landing Page"
              name    = "inscritos.xls"
              type    = "csv"
            >
              <v-btn
              dark
              large
              color="primary-button"
              depressed
              class="round-corner"
            >Exportar .csv</v-btn>
            </download-excel>

          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <!-- NEW ADMIN -->
      <!-- <v-col cols="12" md="6">
        <v-card class="grey lighten-4 pb-0">
          <v-card-title class="grey darken-4 white--text">
            Adicione mais um administrador
          </v-card-title>
          <v-card-text class="pt-8">
            <v-text-field
              label="Email"
              outlined
              type="email"
              placeholder="exemplo@email.com"
              id="admin-email"
              v-model="adminEmail"
              clearable
              append-icon="mdi-account-plus ml-2 pa-2 full-round-corner"
              @click:append="addAdmin"
            ></v-text-field>
          </v-card-text>
        </v-card>
      </v-col> -->
      <!-- GO TO INDEX -->
      <v-row class="d-flex justify-center pa-2 mx-4 my-8">
        <!-- <v-col cols="12" class="justify-center align-center d-flex">
          <v-btn
            color="primary"
            :to="'/'"
            x-large
            outlined
          >Ver como usuário</v-btn>
        </v-col> -->
      </v-row>
    </v-row>

    <!-- DIALOG -->
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      min-width="290"
      max-width="80%"
    >
      <v-card>
        <v-card-title class="teal white--text headline" v-if="this.dialogTitle">{{ dialogTitle }}</v-card-title>

        <v-card-text class="pt-6" style="height: 450px;">
          <v-text-field
            label="Url"
            outlined
            type="text"
            v-model="newUrl"
            clearable
            dense
            prepend-icon="mdi-earth"
          ></v-text-field>

          <v-text-field
            label="Título"
            outlined
            type="text"
            v-model="newTitle"
            clearable
            dense
            prepend-icon="mdi-format-text-variant-outline"
          ></v-text-field>

          <v-textarea
            full-width
            single-line
            label="Descrição"
            outlined
            type="text"
            v-model="newContent"
            prepend-icon="mdi-format-align-left"
          ></v-textarea>

          <v-text-field
            label="Patrocinador"
            outlined
            type="text"
            v-model="newPatrocinio[0]"
            clearable
            dense
            prepend-icon="mdi-currency-usd"
          ></v-text-field>

          <!-- <v-text-field
            label="Organizadores"
            outlined
            type="text"
            v-model="newSponsors"
            clearable
            dense
          ></v-text-field> -->
          <div class="mb-4">
            <v-icon class="mr-2">mdi-account-multiple</v-icon>
            <span class="overline">Organizadores</span>

            <v-icon
              color="green"
              @click="sponsor_counter ++"
            >mdi-plus</v-icon>
            <v-icon
              color="red"
              @click="sponsor_counter --"
            >mdi-minus</v-icon>
          </div>

          <div v-for="(field, i) in sponsor_counter" :key="i">
            <v-text-field
              :label="'Organizador ' + (i+1)"
              v-model="newSponsors[i]"
              outlined
              dense
            >
              <v-icon slot="append" @click="removeSponsor(i)">mdi-close</v-icon>
            </v-text-field>
          </div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4 teal">

          <v-btn
            class="white--text"
            @click="dialog = false"
            large
            text
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="white teal--text"
            @click="printResult()"
            depressed
            large
            class=""
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ------- SNACKBAR FEEDBACK -------- -->
    <v-snackbar v-if="feedback" :color="feedback.color" :class="feedback.textColor" v-model="feedback.show">
      {{feedback.message}}
      <v-btn :class="feedback.textColor" outlined @click="feedback.show = false" v-if="feedback.btnTxt">
        {{feedback.btnTxt}}
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import firebase from 'firebase'
// import admin from 'firebase/admin'
// import functions from 'firebase/functions'
import db from '@/firebase/init'
import moment from 'moment'
import JsonExcel  from 'vue-json-excel'
import BackupBtn from '@/components/admin/BackupBtn.vue'
import BackupUsers from '@/components/admin/BackupUsers.vue'
import CommentsAdmin from '@/components/admin/CommentsAdmin.vue'
import NewInsc from '@/components/admin/NewInsc.vue'
import GoLiveSwitch from '@/components/admin/GoLiveSwitch.vue'
import {mapGetters, mapActions} from "vuex"

export default {
  name: 'Admin',
  components: {
    'downloadExcel': JsonExcel,
    'BackupBtn' : BackupBtn,
    'BackupUsers' : BackupUsers,
    'CommentsAdmin': CommentsAdmin,
    'GoLiveSwitch': GoLiveSwitch,
    NewInsc,
  },
  data(){
    return{
      videoId: 'cc3',
      user: null,
      adminEmail: null,
      video: {},
      videos: [],
      show: false,
      userCount: 0,
      usuarios: [],
      headers: [
        { text: 'Autorizou', value: 'autorizou'},
        { text: 'Nome', value: 'name'},
        { text: 'Sobrenome', value: 'lastname'},
        { text: 'Email', value: 'email'},
        { text: 'Telefone', value: 'tel'},
        { text: 'Epecialidade', value: 'especialidade'},
        { text: 'Nascimento', value: 'dtNasc'},
        { text: 'Estado', value: 'estado'},
        { text: 'Sexo', value: 'sexo'},
        { text: 'CPF', value: 'cpf'},
        { text: 'CRM', value: 'crm'},
        { text: 'Cadastro', value: 'tsCadastro'},
      ],
      sortBy: 'tsCadastro',
      sortDesc: true,
      search: '',
      loading: true,
      bg: null,
      loadingBg: false,
      feedback: {
        show: false,
        message: '',
        btnTxt: '',
        color: '',
        textColor: ''
      },
      newBg: null,
      dialog: false,
      dialogTitle: '',
      newUrl: null,
      newTitle: null,
      newContent: null,
      newPatrocinio: [],
      newSponsors: [],
      sponsor_counter: 0,
      newTimestamp: null,
      json_data: [],
      json_fields: {
          'Autorizou': 'autorizou',
          'Nome': 'nome',
          'Sobrenome': 'sobrenome',
          'Email': 'email',
          'Telefone': 'tel',
          'Especialidade': 'especialidade',
          'Nascimento': 'dtNasc',
          'Estado': 'estado',
          'Sexo': 'sexo',
          'CPF': 'cpf',
          'CRM': 'crm',
          'Cadastro': 'tsCadastro',
      },
      loadingCsv: false,
    }
  },
  computed: {
    ...mapGetters(['getGoLiveEnabled', 'getUserData', 'getUser']),
  },
  mounted(){
    this.$vuetify.theme.dark = true
    moment.locale('pt-br')
    firebase.auth().onAuthStateChanged(user => {
      // this.user = user
      // console.log(user)
      this.getUserInfo(user)
    })
    this.getVideo(this.videoId)
    this.getUsuarios()
    // this.getBg()
    this.getData()
    // this.getUsers()
  },
  methods: {
    ...mapActions(['toggleGoLiveAction', 'test', 'getVideoAction', 'findUser']),

    setFeedback(show, message, btnTxt, color, textColor){
      this.feedback = {
        show: show,
        message: message,
        btnTxt: btnTxt,
        color: color,
        textColor: textColor
      }
    },
    getData(){
      this.json_data = []
      // window.console.log('oi')
      db.collection('usuarios').get()
        .then(snapshot => {
          let c = 0
          snapshot.docs.forEach(doc => {
            // console.log(doc.data())
            c ++

            this.json_data.push(doc.data())
          });

          // console.log(c)
          // console.log(this.json_data)
        })
    },
    startDownload(){
      // alert('show loading');
      this.loadingCsv = true
    },
    finishDownload(){
      // alert('hide loading');
      this.loadingCsv = false
    },
    changeBg(){
      // console.log(this.newBg)

      if (this.newBg){
        this.loadingBg = true

        var storageRef = firebase.storage().ref();
        var folderRef = storageRef.child('/img/bg.png')
        var file = this.newBg
        file.filename = this.newBg.name

        folderRef.put(file).then(() => {
          // console.log('Uploaded a blob or file!');

          this.loadingBg = false

          this.setFeedback(true, 'Sua imagem foi enviada com sucesso!', 'OK', 'green', 'white--text')
          this.getBg()
          this.newBg = null
        })

      }else {
        this.setFeedback(true, 'Escolha um arquivo para enviar', 'OK', 'amber', 'black--text')
      }
    },
    removeSponsor(i){
      this.newSponsors.splice(i, 1)
      this.sponsor_counter --
    },
    openEdit(){
      this.dialogTitle = 'Editar vídeo em destaque'
      this.sponsor_counter = 0
      this.dialog = true
      this.newUid = this.video.videoId
      this.newUrl = this.video.url
      this.newTitle = this.video.title
      this.newContent = this.video.content
      this.newPatrocinio = this.video.patrocinio
      this.newSponsors = []
      this.video.sponsors.forEach(sponsor => {
        this.newSponsors.push(sponsor)
        this.sponsor_counter ++
      })
      this.newTimestamp = this.video.dateAdded
    },
    printResult(){
      console.log(
        'uid: ', this.newUid,
        'url: ', this.newUrl,
        'titulo: ', this.newTitle,
        'content: ', this.newContent,
        'patrocinio: ', this.newPatrocinio,
        'sponsors: ', this.newSponsors
      )
      let ref = db.collection('videos')
      if (this.newUid) {
        ref.doc(this.newUid).update({
          url: this.newUrl,
          title: this.newTitle,
          content: this.newContent,
          patrocinio: this.newPatrocinio,
          sponsors: this.newSponsors,
        })
        .then(() => {
          console.log('Documento alterado com sucesso')
          this.setFeedback(true, 'Vídeo alterado com sucesso!', 'OK', 'green', 'white--text')
          this.dialog = false
          this.newUrl = null
          this.newTitle = null
          this.newContent = null
          this.newPatrocinio = []
          this.newSponsors = []
          this.getVideo()
        })
        .catch(err => {
          this.setFeedback(true, err.message, 'OK', 'red', 'white--text')
          console.log('erro ao alterar video no banco: ', err.message)
        })
      } else {
        ref.where('display', '==', true)
        .get()
        .then(snapshot => {
          snapshot.docs.forEach(doc => {
            let i = doc.data()
            ref.doc(doc.id).update({
              display: false
            })
            .then(() => {
              console.log('id alterado')
            })
            console.log(i.display)
            console.log(doc.id)
          })
          this.AddVideo(ref);
        })
        .catch(err => {
          console.log('erro ao obter os vídeos: ', err.message)
        })
      }
    },
    AddVideo(ref){
      ref.add({
        url: this.newUrl,
        title: this.newTitle,
        content: this.newContent,
        patrocinio: this.newPatrocinio,
        sponsors: this.newSponsors,
        display: true,
        ts: Date.now(),
        dt: moment(Date.now()).format('DD-MM-YYYY')
      })
      .then(() => {
        console.log('Documento adicionado com sucesso')
        this.setFeedback(true, 'Vídeo adicionado com sucesso!', 'OK', 'green', 'white--text')
        this.dialog = false
        this.getVideo()
      })
      .catch(err => {
        console.log('erro ao adicionar video no banco: ', err.message)
        this.setFeedback(true, 'erro ao adicionar video no banco: ' + err.message, 'OK', 'red', 'white--text')
      })
    },
    openAdd(){
      this.dialogTitle = 'Adicionar vídeo em destaque'
      this.sponsor_counter = 1
      this.dialog = true
      this.newUid = null
      this.newUrl = null
      this.newTitle = null
      this.newContent = null
      this.newPatrocinio = []
      this.newSponsors = []
      // this.newTimestamp = this.video.dateAdded
    },
    getBg(){
      var storageRef = firebase.storage().ref();
      var folderRef = storageRef.child('img')
      var fileName = 'bg.png';
      let bg = folderRef.child(fileName)
      bg.getDownloadURL().then(imgUrl => {
        this.bg = imgUrl
        // console.log(this.bg)
      })
    },
    getUsuarios(){
      this.loading = true
      db.collection('usuarios').get().then(snapshot => {
        snapshot.docs.forEach(doc => {
          let user = doc.data()
          this.usuarios.push(user)
          this.userCount++
        })
        this.loading = false
      })
    },
    getUserInfo(user) {
      db.collection('usuarios')
        .where('email', '==', user.email)
        .get()
        .then((users) => {
          users.forEach(doc => {
            // console.log(doc.data())
            this.user = doc.data()
          });
        })
    },
    getVideo(id){
      db.collection('videos')
        .doc(id)
        .get()
        .then(doc => {
          let video = doc.data()
          video.videoId = doc.id

          if(video.display){
            this.video = video
            this.video.url = video.url
          } else{
            // console.log('video sem display')
            this.videos.push(video)
          }
        })
        .catch((e) => console.error('erro ao buscar o vídeo: ', e.message))
      // console.log(this.videos)
    },
    // getUsers(){
    //   const getAllUsers = firebase.functions().httpsCallable('getAllUsers')
    //   getAllUsers().then(result => {
    //     console.log(result)
    //   })
    // },
    addAdmin(){
      if(this.adminEmail){
        this.feedback = null
        // window.console.log(this.adminEmail)
        const adminEmail = this.adminEmail
        const addAdminRole = firebase.functions().httpsCallable('addAdminRole')
        addAdminRole({ email: adminEmail }).then(result => {
          window.console.log(result)
          this.adminEmail = null
        })
      } else {
        this.setFeedback(true, 'O campo email deve ser preenchido', 'OK', 'amber', 'black--text')
      }
    },
    // async addPreInsc3(email) {
    //   this.$store.commit('toggleLoadingPage')
    //   await db.collection('pre-insc3').doc(email)
    //     .set({
    //       email: email,
    //       checked: false
    //     })
    //     .then(() => {
    //       this.$store.commit('toggleLoadingPage')
    //       alert(email + ' foi adicionado(a) a lista.')
    //       return true
    //     })
    //     .catch((e) => {
    //       console.error('addPreInsc erro: ', e.message)
    //       this.$store.commit('toggleLoadingPage')
    //       return false
    //     })
    // }
  },
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

.admin{
  .z-2{
    z-index: 2;
  }
  .bg{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
    background-color: $primary;
    min-height: 400px;
  }
  .addBG{
    border: solid 3px;
    border-color: #eeeeee !important;
    border-style: dashed;
  }
}

</style>